__turbopack_context__.v({
  "badge": "PromoBadge-module__jWjvUG__badge",
  "overlay": "PromoBadge-module__jWjvUG__overlay",
});
